<div class="time-range" [class.time-range--large]="isLarge">
  <div [class.time-range__controls]="!verticalAlign" [class.time-range__controls--vertical]="verticalAlign">
    <div class="time-range__controls__time">
      <ftr-time-input
        #startTimeInput
        [label]="startLabel"
        name="start"
        [control]="control.controls.start"
        [submitAttempted]="submitAttempted"
        [highlightError]="highlightError"
        [placeholder]="internalPlaceholder"
        [timeFormat]="internalTimeFormat"
        (inputChanged)="propagateInputChangedEvent()"
        [invalidTimeMessage]="invalidTimeMessage"
        [timeStringParseMethods]="timeStringParseMethods"
        [showIcon]="showIcons"
        [isLarge]="isLarge"
      />
    </div>
    <div class="time-range__controls__time">
      <ftr-time-input
        [label]="endLabel"
        name="end"
        [control]="control.controls.end"
        [submitAttempted]="submitAttempted"
        [highlightError]="highlightError"
        [placeholder]="internalPlaceholder"
        [timeFormat]="internalTimeFormat"
        (inputChanged)="propagateInputChangedEvent()"
        [invalidTimeMessage]="invalidTimeMessage"
        [timeStringParseMethods]="timeStringParseMethods"
        [showIcon]="showIcons"
        [isLarge]="isLarge"
      />
    </div>
  </div>
  <span
    ftrValidationErrorHint
    class="input__validation time-range__range-validation"
    [ngFormControl]="control"
    [controlTouched]="control.touched"
    [submitAttempted]="submitAttempted"
    label="Time Range"
  ></span>
</div>
